import { SolanaAdapter } from "@reown/appkit-adapter-solana/react";
import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import type { AppKitNetwork } from "@reown/appkit/networks";

import {
  arbitrum,
  avalanche,
  bsc,
  mainnet,
  solana,
  tron,
} from "@reown/appkit/networks";

// Your WalletConnect Cloud project ID
export const projectId = process.env.NEXT_PUBLIC_WEB3_MODAL_ID;

export const metadata = {
  name: "Denomos",
  description:
    "Transform your crypto portfolio analysis with Denomos's comprehensive analytics suite. Connect your wallet, import CSV, or add manually. Track concentration, correlation, and category metrics in real-time.",
  url: process.env.NEXT_PUBLIC_BASE_URL,
  icons: ["https://www.denomos.com/icon-512x512.png"],
};

export const networks: [AppKitNetwork, ...AppKitNetwork[]] = [
  solana,
  mainnet,
  bsc,
  avalanche,
  arbitrum,
  tron,
];

export const solanaWeb3JsAdapter = new SolanaAdapter({});

export const wagmiAdapter = new WagmiAdapter({
  ssr: true,
  networks,
  projectId,
});

export const config = wagmiAdapter.wagmiConfig;
